import { Modal } from "ant-design-vue";
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import { fmtMsg } from "vue-glcommonui";
import { vuexName, MODULES } from "@/store/utils";
import { ClassSetUp } from "@/locales/localeid";

export default defineComponent({
  components: { Modal },
  setup() {
    const { getters, commit } = useStore();
    const isOpen = computed<string>(() => getters[vuexName(MODULES.DEVICE.GETTERS.IS_SETTING_DEVICE_MODAL_OPEN)]);
    const view = computed<object>(() => getters[vuexName(MODULES.DEVICE.GETTERS.SETTING_DEVICE_MODAL_VIEW)]);
    const handleCancel = () => {
      commit(vuexName(MODULES.DEVICE.COMMITS.TOGGLE_DEVICE_SETTING_MODAL), {
        isOpen: false,
      });
    };

    const Title = computed(() => fmtMsg(ClassSetUp.DeviceSettings));
    return {
      isOpen,
      view,
      handleCancel,
      Title,
    };
  },
});
